




























































import { Component, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import firebase from 'firebase';
import { FirebaseModule } from '@/module/firebase';
import { mapGetters } from 'vuex';
import GlobalHeaderContainer from '@/components/Header/container.vue';
import GlobalFooterContainer from '@/components/Footer/container.vue';
import LoadingContainer from '@/components/Loading/container.vue';

interface CharacterSheet {
  id: string;
  name: string;
  job: string;
}
@Component({
  components: {
    GlobalHeaderContainer,
    GlobalFooterContainer,
    LoadingContainer,
  },
})
export default class Mypage extends Vue {
  private cslist: CharacterSheet[] = [];
  private postnum: number = 0;
  private firebaseModule = new FirebaseModule();
  private isProgress: boolean = true;

  @Getter('User/getUser') private user;
  @Getter('User/getStatus') private userStatus;

  public async init() {
    await this.firebaseModule.onAuth();
    if (this.userStatus) {
      firebase
        .firestore()
        .collection('Character')
        .where('userid', '==', this.user.uid)
        .get()
        .then(querySnapshot => {
          querySnapshot.docs.forEach(element => {
            const data = {
              id: element.id,
              name: element.data().profile.name,
              job: element.data().profile.job,
            };
            this.cslist.push(data);
            this.postnum++;
          });
          this.isProgress = false;
        });
    } else {
      this.$router.push('/signin');
    }
  }

  public profileEntry() {
    if (!this.user.displayName) {
      return;
    }

    this.user
      .updateProfile({
        displayName: this.user.displayName,
      })
      .then()
      .catch();
  }

  public created() {
    this.init();
  }
}
